import { motion } from "framer-motion";

import type { IConcreteEffectProps } from "../types.js";

import { Animatable } from "./Animatable";

export function FadeIn({
  active,
  children,
  duration,
  className,
}: IConcreteEffectProps) {
  return (
    <Animatable active={active}>
      <motion.div
        key="fadeIn"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: duration ?? 1 }}
        className={className}>
        {children}
      </motion.div>
    </Animatable>
  );
}
